module.exports = __webpack_public_path__ + "img/官方教程.f17a5edb.png";